let authenticationActionTypes = {
    TOKEN: 'TOKEN',
    RESET_TOKEN: 'RESET_TOKEN',
    PROFILE: 'PROFILE',
    GET_PROFILE: 'GET_PROFILE',
    GET_JWT_USER: 'GET_JWT_USER',
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT'
}

export default authenticationActionTypes
